<template>
  <div class="life" v-if="load">
    <div class="banner">
      <img :src="banner.cover" alt />
    </div>
    <!-- 1 -->
    <div class="row" id="life1">
      <div class="column small-12 medium-4 large-4">
        <div
          style="background: #fff;color: #000;"
          class="left-text content-tile content-tile-subhead clearfix has-body has-cta content-tile-subhead content-tile-subhead-tall invert"
        >
          <h2>
            <div
              class="field field--name-name field--type-string field--label-hidden field__item"
            >{{type1.name}}</div>
          </h2>

          <div class="button">
            <a :href="`/lifeDetails?id=${type1.list[0].id}`">更多</a>
          </div>

          <div
            class="field field--name-field-tiles-body field--type-text-long field--label-hidden field__item"
          >
            <p>{{type1.list[0].brief}}</p>
          </div>
        </div>
      </div>
      <div class="column small-12 medium-8 large-8">
        <div class="row small-squre">
          <a :href="`/lifeDetails?id=${type1.list[0].id}`">
            <img style="width: 100%" :src="type1.list[0].cover" alt />
          </a>
        </div>
        <div class="row small-squre moblie-hidden">
          <div class="column small-6 medium-6 large-6">
            <a :href="`/lifeDetails?id=${type1.list[1].id}`">
              <img style="width: 100%" :src="type1.list[1].cover" alt />
            </a>
          </div>
          <div class="column small-6 medium-6 large-6">
            <a :href="`/lifeDetails?id=${type1.list[2].id}`">
              <img style="width: 100%" :src="type1.list[2].cover" alt />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- 2 -->
    <div class="row" id="life2">
      <div class="column small-12 medium-8 large-8">
        <div class="row small-squre">
          <a :href="`/lifeDetails?id=${type2.list[0].id}`">
            <img style="width: 100%" :src="type2.list[0].cover" alt />
          </a>
        </div>
        <div class="row small-squre moblie-hidden">
          <a :href="`/lifeDetails?id=${type2.list[1].id}`">
            <img style="width: 100%" :src="type2.list[1].cover" />
          </a>
        </div>
      </div>
      <div class="column small-12 medium-4 large-4">
        <div
          class="left-text content-tile content-tile-subhead clearfix has-body has-cta content-tile-subhead content-tile-subhead-tall invert"
        >
          <h2>
            <div
              class="field field--name-name field--type-string field--label-hidden field__item"
            >{{type2.name}}</div>
          </h2>
          <div class="button">
            <a :href="`/lifeDetails?id=${type2.list[0].id}`">更多</a>
          </div>
          <div
            class="field field--name-field-tiles-body field--type-text-long field--label-hidden field__item"
          >
            <p>{{type2.list[0].brief}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div class="special-box">
      <div class="banner" id="life3">
        <a :href="`/lifeDetails?id=${type3.list[0].id}`">
          <img :src="type3.list[0].cover" alt />
        </a>
      </div>
      <!-- 4 -->
      <!-- 5 -->
      <div class="row" id="life4">
        <div class="columns small-12 large-3 padme medium">
          <h2>
            <div
              class="field field--name-name field--type-string field--label-hidden field__item"
            >{{type3.name}}</div>
          </h2>

          <div class="button">
            <a :href="`/lifeDetails?id=${type3.list[0].id}`">更多</a>
          </div>
        </div>
        <div class="columns small-12 large-9 padme medium">
          <div
            class="field field--name-field-tiles-body field--type-text-long field--label-hidden field__item"
          >
            <p>{{type3.list[0].brief}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 6 -->
    <div class="row">
      <div class="column small-12 medium-4 large-4">
        <div
          style="height: 25vw"
          class="content-tile content-tile-subhead clearfix has-body has-cta content-tile-subhead content-tile-subhead-tall invert"
        >
          <h2>
            <div
              class="field field--name-name field--type-string field--label-hidden field__item"
            >{{type4.name}}</div>
          </h2>

          <div class="button">
            <a :href="`/lifeDetails?id=${type4.list[0].id}`">更多</a>
          </div>

          <div
            class="field field--name-field-tiles-body field--type-text-long field--label-hidden field__item"
          >
            <p>{{type4.list[0].brief}}</p>
          </div>
        </div>
      </div>
      <div class="column small-12 medium-4 large-4 moblie-hidden">
        <div class="row small-squre">
          <a :href="`/lifeDetails?id=${type4.list[0].id}`">
            <img style="width: 100%" :src="type4.list[0].cover" alt />
          </a>
        </div>
      </div>
      <div class="column small-12 medium-4 large-4 moblie-hidden">
        <div class="row small-squre">
          <a :href="`/lifeDetails?id=${type4.list[1].id}`">
            <img style="width: 100%" :src="type4.list[1].cover" />
          </a>
        </div>
      </div>
    </div>
    <!-- 5 -->
    <div class="row" id="life5">
      <div class="column small-12 medium-8 large-8">
        <div class="row large-squre">
          <a :href="`/lifeDetails?id=${type5.list[0].id}`">
            <img style="width: 100%" :src="type5.list[0].cover" alt />
          </a>
        </div>
      </div>
      <div class="column small-12 medium-4 large-4">
        <div
          style="background: #fff;color: #000;"
          class="small-left-text content-tile content-tile-subhead clearfix has-body has-cta content-tile-subhead content-tile-subhead-tall invert"
        >
          <h2>
            <div
              class="field field--name-name field--type-string field--label-hidden field__item"
            >{{type5.name}}</div>
          </h2>

          <div class="button">
            <a :href="`/lifeDetails?id=${type5.list[0].id}`">更多</a>
          </div>
          <div
            class="field field--name-field-tiles-body field--type-text-long field--label-hidden field__item"
          >
            <p>{{type5.list[0].brief}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 6 -->
    <div class="row" id="life6">
      <div class="column small-12 medium-4 large-4">
        <div class="row small-squre fliter-img">
          <a :href="`/lifeDetails?id=${type5.list[1].id}`">
            <img style="width: 100%" :src="type5.list[1].cover" alt />
          </a>
        </div>
      </div>
      <div class="moblie-hidden column small-12 medium-4 large-4 ">
        <div class="row small-squre fliter-img">
          <a :href="`/lifeDetails?id=${type5.list[2].id}`">
            <img style="width: 100%" :src="type5.list[2].cover" alt />
          </a>
        </div>
      </div>
      <div class="moblie-hidden column small-12 medium-4 large-4 ">
        <div class="row small-squre fliter-img">
          <a :href="`/lifeDetails?id=${type5.list[3].id}`">
            <img style="width: 100%" :src="type5.list[3].cover" alt />
          </a>
        </div>
      </div>
    </div>
    <!-- 7 -->
  </div>
</template>

<script>
import { LiveList } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      load: false,
      banner: null,
      type1: null,
      type2: null,
      type3: null,
      type4: null,
      type5: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    LiveList((res) => {
      this.load = true;
      this.$emit("complete", true);
      if (res.code == 0) {
        this.banner = res.data.banner;
        this.type1 = res.data.list.find((item) => item.type === 1);
        this.type2 = res.data.list.find((item) => item.type === 2);
        this.type3 = res.data.list.find((item) => item.type === 3);
        this.type4 = res.data.list.find((item) => item.type === 4);
        this.type5 = res.data.list.find((item) => item.type === 5);
      }
    });
  },
  mounted() {
    document.getElementById("lifeTab").classList.add("is-active");
  },
};
</script>
<style lang='less' scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.life {
  .left-text {
    height: 50vw;
  }
  .small-left-text {
    height: 50vw;
  }
  .row {
    margin: 0;
  }
  .column {
    padding-left: 0;
    padding-right: 0;
  }
  .small-squre {
    height: 25vw;
    img {
      height: 25vw;
    }
  }
  .medium-squre {
    height: 33vw;
    img {
      height: 33vw;
    }
  }
  .large-squre {
    height: 50vw;
    img {
      height: 50vw;
    }
  }
}
.fliter-img {
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    -webkit-filter: gray;
    filter: gray;
    -webkit-filter: grayscale(100%) brightness(0.6);
    filter: grayscale(100%) brightness(0.6);
    -webkit-transition: -webkit-filter 0.15s ease;
    transition: -webkit-filter 0.15s ease;
    transition: filter 0.15s ease;
    transition: filter 0.15s ease, -webkit-filter 0.15s ease;
    &:hover {
      -webkit-filter: grayscale(0) brightness(1);
      filter: grayscale(0) brightness(1);
    }
  }
}
.content-tile p {
  font-size: 1rem;
}
@media print, screen and (max-width: 40em) {
  .life .left-text {
    height: auto !important;
  }
  .invert{
       height: auto !important;
  }
  .content-tile p {
    font-size: 0.9rem;
  }
  .moblie-hidden {
    display: none;
  }
  #life2,
  .special-box {
    display: flex;
    flex-direction: column-reverse;
  }
  .small-squre {
    height: 34vw !important;
    img {
      height: 34vw !important;
    }
  }
}
</style>